import React from 'react';
import VideoSlide from '../../body/VideoSlide';

const Introduction = () => {
  return <VideoSlide vidSrc={1194053333} />;
};

export default Introduction;
